import React from 'react';
import PropTypes from 'prop-types';
import {
  IonToolbar,
  IonButtons,
  IonButton,
  IonModal,
  IonIcon,
  IonText,
  IonContent,
} from '@ionic/react';
import { close } from 'ionicons/icons';

function ItemDescModal({ children, onClose, isOpen }) {
  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose} cssClass="inline-modal">
      <IonToolbar mode="ios">
        <IonButtons slot="end">
          <IonButton onClick={onClose}>
            <IonIcon color="tertiary" slot="icon-only" icon={close} />
          </IonButton>
        </IonButtons>
      </IonToolbar>
      <IonContent>
        <IonText>{children}</IonText>
      </IonContent>
    </IonModal>
  );
}

ItemDescModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
};

export default ItemDescModal;
